import InternalBookingPage from "@components/InternalBookingPage";

export default function NouveauRDVModal({ onClose, onSuccess }: { onClose: () => void; onSuccess?: () => void }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: "rgba(0,0,0,0.4)" }}
    >
      <InternalBookingPage
        onClose={onClose}
        onSuccess={onSuccess}
        internalMode
      />
    </div>
  );
}
